<template>
  <div class="pt-4 px-8 md:ml-12">
    <!--Commented out dummy data-->
    <div v-if="isLoading">
      <div class="flex items-center justify-center w-full h-screen -mt-32">
        <spinner size="medium" :spacing="40" :line-fg-color="$primaryColor" />
      </div>
    </div>
    <div v-else>
      <div>
        <customers-page v-if="isCustomersPage" />
      </div>
    </div>
  </div>
</template>

<script>
import tenant from '@/mixins/tenant'
export default {
  name: 'ExternalApi',
  mixins: [tenant],
  data () {
    return {
      showPage: true,
      isLoading: false
    }
  },
  components: {
    CustomersPage: () =>
      import('@/components/v2/externalApi/layout/CustomersPage.vue')
  },
  computed: {
    externalApiDashboardInformation () {
      return this.$store.state.externalApi.externalApiDashboard
    },
    component () {
      return this.$store.state.externalApi.activeComponent
    },
    isCustomersPage () {
      return this.component === 'AllCustomers'
    }
  },
  methods: {
    goToPage (page) {
      this.$store.dispatch('externalApi/setActiveComponent', page)
    },
    hidePage () {
      this.showPage = false
    },
    showHomePage () {
      this.showPage = true
      this.getExternalApiDashboardInformation()
    },
    goToCreateYieldForm () {
      this.hidePage()
      this.$store.dispatch('externalApi/setActiveComponent', 'YieldProfileForm')
    },
    goToHomePage () {
      this.$store.dispatch('externalApi/setActiveComponent', 'YieldOfferings')
      this.showHomePage()
    },
    async getExternalApiDashboardInformation () {
      const vm = this
      this.isLoading = true
      await this.$store
        .dispatch('externalApi/getExternalApiDashboardInformation')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  updated () {
    if (this.component === 'YieldProfileForm') {
      this.hidePage()
    }
  },
  async mounted () {
    await this.getExternalApiDashboardInformation()
  }
}
</script>

<style scoped>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 1px 3px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
  height: 88px;
}
.card:hover {
  background-color: var(--primary-gradient);
  color: var(--text-2);
}

.activeCard {
  background-color: var(--color-primary);
  color: white;
}
.btn {
  background: rgba(1, 5, 44, 0.05);
  border: 0.719333px solid #c1c4ca;
  border-radius: 6px;
  border: none;
}
</style>
